angular.module("datasets")

    .controller("DatasetsEditCtrl", ['LanguagesService', 'LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal',
        function (LanguagesService, LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal) {

            // Comprobamos si tiene permiso escritura

            $scope.allowWrite = LoginService.permissionExist("DATASETS_WRITE");

            $rootScope.title = $filter('translate')('datasets.title');

            $scope.types = [
                { id: "persons", name: "Autoridades" },
                { id: "events", name: "Eventos" },
                { id: "correspondence", name: "Correspondencia" },
                { id: "groups", name: "Grupos de autoridades" },
                { id: "staff", name: "Personal" },
                { id: "materials", name: "Materiales" },
                { id: "gifts", name: "Almacén de regalos" },
                { id: "persons_gifts", name: "Regalos" },
                { id: "restaurants", name: "Restaurantes" },
                { id: "tasks", name: "Tareas" },
                { id: "event_guests", name: "Invitados de evento" },
                { id: "inscriptions", name: "Inscripciones" },
                { id: "reservation", name: "Reservas" },
                { id: "event_resume", name: "Resumen Eventos" },
                { id: "act_resume", name: "Resumen Actos" },
                { id: "positions", name: "Cargos" }
            ];

            $scope.dataset = {};
            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('datasets.title'), url: "datasets.list" },
                    { title: $filter('translate')('datasets.title_add') },
                ];

            } else {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('datasets.title'), url: "datasets.list" },
                    { title: $filter('translate')('datasets.title_edit') },
                ];

                Restangular.one('Datasets', $stateParams.id).get().then(function (result) {
                    $scope.dataset = result;
                    if ($scope.allowWrite) {
                        if ($scope.dataset.is_system_dataset) {
                            $scope.allowWrite = false;
                        } else {
                            $scope.allowWrite = true;
                        }
                    }
                });

            }

            $scope.save = function () {
                if (angular.isDefined($stateParams.id) && $stateParams.id != "") {
                    $scope.dataset.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('datasets.save_success'));
                            $state.go("datasets.list");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                } else {
                    Restangular.all('Datasets').post($scope.dataset).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('datasets.edit_success'));
                            $state.go("datasets.list");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }
            };

            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('datasets.button_delete'),
                    message: $filter('translate')('datasets.delete_message') + " " + $scope.dataset.name + "?",
                    onAccept: function () {
                        $scope.dataset.remove().then(function () {
                            toastr.success($filter('translate')('datasets.deleted_success'));
                            $state.go("datasets.list");
                        });
                    }
                });
            };

        }]);

